var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import AtSignSvg from './at-sign.icon.svg';
export const AtSignIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: AtSignSvg }));
_react_refresh_temp_1 = AtSignIcon;
$RefreshReg$(_react_refresh_temp_1, "AtSignIcon");
